import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ModalPanel, ModalSidebarContext } from '../../../../../components/ModalSidebar'
import { isScheduleSelected } from '../common/Scheduling/fieldset'
import ReviewContent from './ReviewContent'

const propTypes = {
  /**
   * Employee full name
   */
  employeeFullName: PropTypes.string.isRequired,
  /**
   * information of the user to be removed
   */
  userInfo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
}

function ReviewPanel(props) {
  const { employeeFullName, userInfo = {} } = props ?? {}

  const { submitForm, values } = useFormikContext()

  const { nextStep } = useContext(ModalSidebarContext)

  return (
    <ModalPanel
      leftButton="back"
      rightButton={{
        label: isScheduleSelected(values) ? 'ENGAGE.OFFBOARD.SCHEDULE_OFFBOARDING' : 'ENGAGE.OFFBOARD.OFFBOARD_USER',
        id: isScheduleSelected(values) ? 'schedule-offboarding-submit-btn' : 'offboard-user-submit-btn',
        variant: 'primary',
        onClick: () => {
          submitForm()
          nextStep()
        },
      }}
    >
      <ReviewContent isUserOffboarded={false} employeeFullName={employeeFullName} userInfo={userInfo} />
    </ModalPanel>
  )
}

ReviewPanel.propTypes = propTypes

export default ReviewPanel
